import { mapState } from 'vuex'
import { reqCyQueryAdvert } from 'changyo-public-api'

export default {
  name: 'YBK',
  props: {
    keyId: {
      type: String,
      required: true
    },
    spm: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      text: '畅由元宝卡，开通省28936元/年',
      buttonPic: require('./images/btn-pic.png'),
      linkUrl: location.origin + '/vip/index.html#/homepage',
      showYBK:1
    }
  },
  computed: {
    ...mapState([
      'vip',
      'channel'
    ])
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await reqCyQueryAdvert({
        featuredFirstCode: this.keyId,
        channel: this.channel
      }).catch(err => {
        console.log(err)
      })

      if (res && res.data && res.data.advertiseOnlines) {
        const data = res.data.advertiseOnlines[0]

        if (data) {
          this.text = data.advertiseIntroduce
          this.buttonPic = data.advertiseViewImg
          this.linkUrl = data.jumpLink
        }
      }else{
        this.showYBK=0;
      }
    },
    linkTo() {
      if (this.linkUrl !== '1') {
        location.href = this.linkUrl
      }
    }
  }
}
